<script>

export default ({
  props: {
    filled: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    mostrarIcones: Boolean,
    obrigatorio: Boolean,
    label: {
      type: String,
      required: true,
    },
    componenteData: {
      type: Object,
      default: null,
    },
    isConfigurarCelulaDialogOpen: Boolean,
    isDeletarComponenteDialogOpen: Boolean,
  },
})
</script>
